import {
  QueryCache,
  MutationCache,
  QueryClient,
  QueryClientConfig,
} from '@tanstack/react-query';
import {createContext} from 'react';

import {addError} from 'src/js/containers/status/status_thunks';
import {AppStore} from 'src/js/store';

interface QueryClientInstanceType {
  getClient: (store?: AppStore, config?: QueryClientConfig) => QueryClient;
}
export const QueryClientContext = createContext<QueryClient | undefined>(
  undefined
);

export const QueryClientInstance: QueryClientInstanceType = {
  getClient: (store, config) =>
    new QueryClient({
      ...config,
      queryCache: new QueryCache({
        onError: (error, query) => {
          store?.dispatch(
            addError(
              error,
              query?.queryKey.length >= 1 &&
                typeof query.queryKey[0] === 'string'
                ? query.queryKey[0]
                : undefined
            )
          );
        },
      }),
      mutationCache: new MutationCache({
        onError: (error, variables, context, mutation) => {
          store?.dispatch(
            addError(
              error,
              mutation?.options?.mutationKey &&
                mutation.options.mutationKey.length >= 1 &&
                typeof mutation.options.mutationKey[0] === 'string'
                ? mutation.options.mutationKey[0]
                : undefined
            )
          );
        },
      }),
      defaultOptions: {
        ...config?.defaultOptions,
        queries: {
          ...config?.defaultOptions?.queries,
          // Disable refetch for better performance
          refetchOnWindowFocus: false,
          retry: false,
        },
      },
    }),
};
